import {
  FETCH_ORG_USERS_SUCCESS,
  FETCH_ORG_USERS_FAIL,
  UPDATE_ORG_USER,
  REMOVE_ORG_USER,
  FETCH_INVITATIONS_SUCCESS,
  FETCH_INVITATIONS_FAIL,
  ADD_INVITATION,
  REMOVE_INVITATION,
} from "../constants/usersConstants";

const initialState = {
  orgUsers: [],
  orgUsersError: null,
  invitations: [],
  invitationsError: null,
};

const usersReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_ORG_USERS_SUCCESS:
      return {
        ...state,
        orgUsers: payload,
        orgUsersError: null,
      };
    case FETCH_ORG_USERS_FAIL:
      return {
        ...state,
        orgUsersError: payload,
      };
    case UPDATE_ORG_USER:
      return {
        ...state,
        orgUsers: state.orgUsers.map((u) =>
          u._id === payload._id ? { ...u, ...payload } : u
        ),
      };
    case REMOVE_ORG_USER:
      return {
        ...state,
        orgUsers: state.orgUsers.filter((u) => u._id !== payload),
      };
    case FETCH_INVITATIONS_SUCCESS:
      return {
        ...state,
        invitations: payload,
        invitationsError: null,
      };
    case FETCH_INVITATIONS_FAIL:
      return {
        ...state,
        invitationsError: payload,
      };
    case ADD_INVITATION:
      return {
        ...state,
        invitations: [payload, ...state.invitations],
      };
    case REMOVE_INVITATION:
      return {
        ...state,
        invitations: state.invitations.filter((inv) => inv._id !== payload),
      };
    default:
      return state;
  }
};

export default usersReducer;
